import React from "react";
import { FilterItem, inputCustomStyle } from "../../formStyle";
import { MoodTagAutoComplete } from "App/Molecules/AutoCompletes/Mood";
import { useAuthGrantStore } from "App/Routes/AuthGrant/Store";
import { IdActions } from "App/Routes/AuthGrant/Store/IdList";
import { Info } from "App/Atomics/AutoComplete/TagAutoComplete";

export const MoodExcludeFilter = () => {
  const [{ mode, searchList }, dispatch] = useAuthGrantStore(store => ({
    mode: store.IdList.mode,
    searchList: store.IdList.searchList
  }));
  const excludeMoodList = searchList.Track.excludeMoodList;
  const onSetMoodList = (info: Info[]) => {
    dispatch(IdActions.setExcludeMoodList({ idType: mode, moodList: info }));
  };
  return (
    <FilterItem>
      <div className="item-label">
        <span>무드 제외 리스트</span>
      </div>
      <div className="item-option-wrapper">
        <MoodTagAutoComplete
          style={inputCustomStyle}
          defaultValue={excludeMoodList}
          onBlur={info => info && onSetMoodList(info as Info[])}
        />
      </div>
    </FilterItem>
  );
};
